import React from 'react'
import { useTranslation } from 'react-i18next'

const Blogs_relacionados = ({ blogsRelacionados = [], categorias }) => {

    const [t, i18n] = useTranslation("detail_blog");

    const trackAnalyticsClick = (label) => {
        window.gtag('event', 'click', {
            event_category: 'Detalle Blog',
            event_label: label,
            value: 1
        });
    };

    const formatDate = (date) => {
        if (!date) return "";

        return new Date(date).toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).replaceAll(".", "").toUpperCase();
    };

    const getReadingTime = (txtresumen) => {
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {

            const partes = txtresumen.split("||");

            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim() + " MIN";
            }
        }

        const i = Math.floor(Math.random() * 5) + 1;
        return i + " MIN";
    };

    const cleanResumen = (txt) => {
        if (!txt) return "";
        return txt.split("||")[0];
    };

    const renderBlogItem = (blog, mobile = false) => {

        const liga = `/blog/${blog.tag}`;

        return (
            <article
                key={blog.guid || blog.tag || blog.titulo}
                class="related-list__item"
            >
                <a onClick={() => trackAnalyticsClick('Detalle Blog - Relacionado: '+blog.titulo)}
                    href={liga}
                    class="related-list__inner related-list__item-inner"
                >
                    <div className='div-related-content'>
                        <div className='div-related-content_img'>
                            <img loading="lazy" src={blog.urlImagen} alt={blog.title} />
                        </div>
                        <div className='div-related-content_cont'>
                            <div class="related-list__top-row">

                                <a href={"/" + i18n.language + "/Mi-blog?categoria=" + blog.categorias[0].tagCategory.toLowerCase()}>
                                    <p class="related-list__chip">
                                        {(blog.categorias[0].nombre || "").toUpperCase()}
                                    </p>
                                </a>

                                {mobile && (
                                    <p class="related-list__meta">
                                        {formatDate(blog.fecha)} · {getReadingTime(blog.resumen) + ' DE LECTURA'}
                                    </p>
                                )}

                            </div>

                            <h3 class="related-list__item-title">
                                {blog.titulo}
                            </h3>

                            {blog.resumen && (
                                <p class="related-list__excerpt">
                                    {cleanResumen(blog.resumen)}
                                </p>
                            )}

                            {!mobile && (
                                <p class="related-list__meta">
                                    {formatDate(blog.fecha)} · {getReadingTime(blog.resumen) + ' DE LECTURA'}
                                </p>
                            )}
                        </div>
                    </div>



                </a>
            </article>
        );
    };

    return (
        <>
            {/* Desktop */}
            <div
                class="_ngcontent-ng-c1842723448 _nghost-ng-c2645057839"
                mode="desktop"
                title="Notas relacionadas"
                titleid="related-title-desktop"
            >

                <section
                    class="related-list related-list--desktop"
                    aria-labelledby="related-title-desktop"
                >

                    <div class="related-list__header">

                        <div class="related-list__inner">

                            <h2
                                class="related-list__title"
                                id="related-title-desktop"
                            >
                                {t('related.related-entries')}
                            </h2>

                        </div>

                    </div>

                    {blogsRelacionados.map((blog) =>
                        renderBlogItem(blog, false)
                    )}

                </section>

            </div>

            {/* Mobile */}
            <div
                class="_ngcontent-ng-c1842723448 _nghost-ng-c2645057839"
                mode="mobile"
                title="Notas relacionadas"
                titleid="related-title-mobile"
            >

                <section
                    class="related-list related-list--mobile"
                    aria-labelledby="related-title-mobile"
                >

                    <div class="related-list__header">

                        <div class="related-list__inner">

                            <h2
                                class="related-list__title"
                                id="related-title-mobile"
                            >
                                {t('related.related-entries')}
                            </h2>

                        </div>

                    </div>

                    {blogsRelacionados.map((blog) =>
                        renderBlogItem(blog, true)
                    )}

                </section>

            </div>
        </>
    )
}

export default Blogs_relacionados